import { useState } from "react";
import { Card, Button, Image, Spin } from "antd";
import axiosApi from "../axiosApi/axiosApi";

export default function SignInToHighLevel({ isGhlSignLoading }) {
    const [loading, setLoading] = useState(false);

    const signIn = async () => {
        setLoading(true);
        try {
            const { data } = await axiosApi.get('/getOAuth');
            if (data.url) {
                window.location.href = data.url;
            }
        } catch (error) {
            console.error("Sign-in error:", error);
        }
    };

    return (
        <div 
            style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh' 
            }}
        >
            <Spin spinning={isGhlSignLoading} size="large">
                <Card
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: "center",
                        width: 400,  // Set width for better alignment
                        padding: 20, // Add padding for spacing
                        border: 'none'
                    }}
                >
                    <h4 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "30px" }}>
                        To view marketplace orders and inventory, sign in With GoHighLevel
                    </h4>
                    <div>
                        <Image src="./GHL.jpg" width={60} height={60} style={{ borderRadius: 50, marginBottom: 20 }} />
                    </div>
                    <Button
                        onClick={signIn}
                        type="primary"
                        loading={loading}
                        disabled={loading}
                        style={{
                            padding: "14px 44px",
                            background: "#ce2e28",
                            fontSize: '16px',
                            border: 'none',
                            color: 'white'
                        }}
                    >
                        {loading ? "Signing In..." : "Sign In"}
                    </Button>
                </Card>
            </Spin>
        </div>
    );
}
